module.exports = __webpack_public_path__ + "static/media/qiwi-wallet-logo_original.44200c91.svg";